import { render, staticRenderFns } from "./approval-request.vue?vue&type=template&id=63a3ff2e&scoped=true&lang=pug&"
import script from "./approval-request.vue?vue&type=script&lang=js&"
export * from "./approval-request.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=63a3ff2e&lang=scss&scoped=true&"
import style1 from "./approval-request.vue?vue&type=style&index=1&id=63a3ff2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3ff2e",
  null
  
)

export default component.exports